export default __webpack_public_path__ + "static/media/Software-Gestao-Projetos.2d71390a.webp";